module.exports = {
  lang: {
    t1: `ホーム`,
    t2: `名刺`,
    t3: `フォロー`,
    t4: `連絡先`,
    t5: `メッセージ`,
    t6: `ログイン`,
    t7: `登録`,
    t8: `グローバルビジネス接続新プラットフォーム、企業デジタルマーケティングの新領域`,
    t9: `WeMeet - ログイン（携帯番号）`,
    t10: `携帯番号`,
    t11: `認証コード`,
    t12: `携帯番号を入力してください`,
    t13: `認証コードを入力してください`,
    t14: `取得`,
    t15: `ログイン`,
    t16: `正しい形式の携帯番号を入力してください`,
    t17: `確認コードが送信されました`,
    t18: `確認コードが正しくありません。確認の上、再度入力してください。`,
    t19: `ログインに成功しました`,
    t20: `確認コードは(0)です。{1}分以内に使用してください。`,
    t21: `キャンセル`,
    t22: `確認`,
    t23: `ワンポイントアドバイス`,
    t24: `WeMeetアカウントの登録がまだ完了していません。今すぐ行動し、登録手続きを完了し、多様な互動と無限の可能性をお楽しみください。`,
    t25: `会員登録へ進む`,
    t26: `WeMeet メールログイン`,
    t27: `アカウント名`,
    t28: `メールアドレスを入力してください`,
    t29: `パスワード`,
    t30: `パスワードを入力してください`,
    t31: `パスワードをお忘れですか？`,
    t32: `ログイン`,
    t33: `他のログイン方法`,
    t34: `WeMeet小程序に既に登録されていますか？今すぐ利用してください。`,
    t35: `モバイル番号でログイン`,
    t36: `まずメールアドレスを入力してください。`,
    t37: `まずパスワードを入力してください。`,
    t38: `メールアドレスの形式が正しくありません`,
    t39: `WeMeetのアカウントをお持ちの方は、直接ログインできます`,
    t40: `ログイン`,
    t41: `プロフィール写真`,
    t42: `プロフィール写真として実際の写真をアップロードしてください`,
    t43: `全名`,
    t44: `名`,
    t45: `姓`,
    t46: `会社名`,
    t47: `所属機関名を入力してください`,
    t48: `役職`,
    t49: `所属機関内の役職名を入力してください`,
    t50: `メールアドレス`,
    t51: `メールアドレスを入力してください`,
    t52: `携帯番号`,
    t53: `携帯番号を入力してください`,
    t54: `地域`,
    t55: `地域を選択してください`,
    t56: `区域`,
    t57: `省・市・区を選択してください`,
    t58: `住所`,
    t59: `住所を入力してください`,
    t60: `WeMeetの利用規約とプライバシーポリシーをお読みいただき、同意したものとみなします。`,
    t61: `利用規約`,
    t62: `プライバシーポリシー`,
    t63: `続きへ`,
    t64: `まずは利用規約に同意のチェックをしてください`,
    t65: `名前を入力してください`,
    t66: `姓を入力してください`,
    t67: `まずメールアドレスを入力してください`,
    t68: `まずは組織名を入力してください`,
    t69: `メールアドレスの形式が正しくありません`,
    t70: `キャンセル`,
    t71: `完了する`,
    t72: `携帯電話番号の確認`,
    t73: `携帯番号`,
    t74: `認証コード`,
    t75: `認証コードを入力してください`,
    t76: `取得`,
    t77: `確認をスキップする`,
    t78: `提出する`,
    t79: `確認済み`,
    t80: `確認コードが正しくありません。確認の上、再度入力してください。`,
    t81: `スキップされました`,
    t82: `ワンポイントアドバイス`,
    t83: `入力された電話番号はWeMeetのアカウントに登録されています。再度登録する必要はありません。今すぐログインしてください。`,
    t84: `ログイン画面へ`,
    t85: `ワンポイントアドバイス`,
    t86: `入力されたメールアドレスはWeMeetのアカウントに登録されています。再度登録する必要はありません。今すぐログインしてください。`,
    t87: `ログイン画面へ`,
    t88: `確認用リンクが送信されました。`,
    t89: `メールボックスを確認し、リンクをクリックして登録を完了してください。`,
    t90: `分かりました`,
    t91: `WeMeetへようこそ`,
    t92: `WeMeetへようこそ！ボタンをクリックして登録を完了してください。あたたかいお知らせ：このリンクは24時間有効です。できるだけ早く操作してください。`,
    t93: `登録完了`,
    t94: `メールアドレスが有効化されました。パスワードを入力してください。`,
    t95: `パスワードを入力`,
    t96: `パスワードを入力してください`,
    t97: `パスワードの確認`,
    t98: `パスワードを再入力してください`,
    t99: `大文字・小文字、数字、記号の組み合わせで、8文字から20文字以内で入力してください`,
    t100: `パスワードを入力してください`,
    t101: `パスワードを再入力してください`,
    t102: `パスワードが一致しません`,
    t103: `登録が完了しました、おめでとうございます`,
    t104: `WeMeetにログインされました。これまでの操作を続けられます。`,
    t105: `エクスペリエンスを続ける`,
    t106: `ワンポイントアドバイス`,
    t107: `リンクが期限切れになりました。再度取得するには、ボタンをクリックしてください。`,
    t108: `再送信`,
    t109: `利用規約`,
    t110: `プライバシーポリシー`,
    t111: `パスワードを再設定`,
    t112: `パスワードを再設定したいアカウントを入力してください`,
    t113: `アカウント名`,
    t114: `メールアドレスを入力してください`,
    t115: `提出する`,
    t116: `まずメールアドレスを入力してください。`,
    t117: `メールアドレスの形式が正しくありません`,
    t118: `メールを送信しました`,
    t119: `メールボックスを確認し、リンクをクリックしてパスワードを再設定してください。`,
    t120: `分かりました`,
    t121: `パスワードのリセット - WeMeet`,
    t122: `パスワードのリセット要求が確認されました。システムにより一時的なパスワードリセット用リンクが生成されました。あたたかいお知らせ：このリンクは24時間有効です。できるだけ早く操作してください。`,
    t123: `パスワードをリセットする`,
    t124: `パスワードのリセットに成功しました`,
    t125: `WeMeetにログインされました。おかえりなさい。`,
    t126: `ホームへ移動`,
    t127: `連絡先`,
    t128: `新しい連絡先申請`,
    t129: `同意する`,
    t130: `無視する`,
    t131: `承認済み`,
    t132: `無視済み`,
    t133: `フォロー`,
    t134: `フォローされています`,
    t135: `メッセージ`,
    t136: `保留中のリクエスト`,
    t137: `名前または電話番号を入力してください`,
    t138: `検索結果が見つかりませんでした`,
    t139: `これ以上ありません`,
    t140: `連絡希望`,
    t141: `同意する`,
    t142: `無視する`,
    t143: `承認済み`,
    t144: `無視済み`,
    t145: `WeMeet AIスペース`,
    t146: `フォロー中`,
    t147: `フォロー解除済み`,
    t148: `vCard`,
    t149: `接続`,
    t150: `メッセージを送信`,
    t151: `承認待ち`,
    t152: `連絡先を削除`,
    t153: `自己紹介`,
    t154: `プロフィール`,
    t155: `ワンポイントアドバイス`,
    t156: `連絡希望が送信されました。承認されると、自動的にTAをフォローします。または、現在からTAをフォローして、より詳しく情報を入手することもできます。`,
    t157: `まだフォローしない`,
    t158: `フォロー`,
    t159: `フォロー中`,
    t160: `連絡先関係を解除する`,
    t161: `連絡先関係を解除した後、相手は個人情報を閲覧できなくなりますが、同時にフォロー解除されることはありません。`,
    t162: `思い直す`,
    t163: `連絡先を削除`,
    t164: `操作成功`,
    t165: `WeMeet AIアシスタント`,
    t166: `お問い合わせを入力してください`,
    t167: `送信`,
    t168: `注意：AIとの対話内容が正確でない場合があり、プラットフォームの見解を代表しない場合があります。`,
    t169: `WeMeet名刺`,
    t170: `ダウンロード`,
    t171: `名刺編集`,
    t172: `QRコードダウンロード`,
    t173: `画像が生成されました。保存してください。QRコードをスキャンして連絡先を保存します。`,
    t174: `プロフィール写真`,
    t175: `プロフィール写真として実際の写真をアップロードしてください`,
    t176: `全名`,
    t177: `名`,
    t178: `姓`,
    t179: `お名前を入力してください`,
    t180: `会社名`,
    t181: `所属機関名を入力してください`,
    t182: `役職`,
    t183: `所属機関内の役職名を入力してください`,
    t184: `メールアドレス`,
    t185: `メールアドレスを入力してください`,
    t186: `携帯番号`,
    t187: `携帯番号を入力してください`,
    t188: `地域`,
    t189: `地域を選択してください`,
    t190: `区域`,
    t191: `省・市・区を選択してください`,
    t192: `アドレス`,
    t193: `住所を入力してください`,
    t194: `名前を入力してください`,
    t195: `姓を入力してください`,
    t196: `まずメールアドレスを入力してください`,
    t197: `まずは組織名を入力してください`,
    t198: `メールアドレスの形式が正しくありません`,
    t199: `チャットルーム`,
    t200: `写真ギャラリー`,
    t201: `写真を撮る`,
    t202: `メッセージを入力してください`,
    t203: `送信`,
    t204: `読了`,
    t205: `未読`,
    t206: `取消期間が切れています`,
    t207: `キャンセル`,
    t208: `写真（しゃしん）`,
    t209: `アルバム (arubamu)`,
    t210: `撮影（さつえい）`,
    t211: `アルバムから選ぶ (arubamu kara erabu)`,
    t212: `キャンセル`,
    t213: `写真（しゃしん）`,
    t214: `ポートレート (pōtorēto)`,
    t215: `プレビュー (purēbī)`,
    t216: `完了する`,
    t217: `WeMeet AIスペース`,
    t218: `お問い合わせ`,
    t219: `私にお問い合わせください`,
    t220: `全名`,
    t221: `機関`,
    t222: `役職`,
    t223: `電話`,
    t224: `メールアドレス`,
    t225: `地域`,
    t226: `区域`,
    t227: `住所`,
    t228: `お名前を入力してください`,
    t229: `お組織名をご入力ください`,
    t230: `お役職をご入力ください`,
    t231: `電話番号を入力してください`,
    t232: `おメールアドレスをご入力ください`,
    t233: `地域を選択してください`,
    t234: `省・市・区を選択してください`,
    t235: `住所をご入力ください`,
    t236: `意向`,
    t237: `商品購入`,
    t238: `取扱商品`,
    t239: `市場提携`,
    t240: `その他`,
    t241: `お名前を入力してください`,
    t242: `お組織名をご入力ください`,
    t243: `おメールアドレスをご入力ください`,
    t244: `メールアドレスの形式が正しくありません`,
    t245: `メッセージが投稿されました`,
    t246: `メッセージを残す`,
    t247: `お問い合わせ内容を入力してください`,
    t248: `確認`,
    t249: `まずはログインまたは会員登録をお願いします`,
    t250: `フォロワー数`,
    t251: `お問い合わせ`,
    t252: `商品`,
    t253: `チーム`,
    t254: `概要`,
    t255: `アルバム`,
    t256: `資格`,
    t257: `登録資本金`,
    t258: `設立日`,
    t259: `登録住所`,
    t260: `アップストリーム`,
    t261: `ミッドストリーム`,
    t262: `ダウンストリーム`,
    t263: `연관 산업`,
    t264: `プロセス`,
    t265: `保存する`,
    t266: `検証済み`,
    t267: `中国語`,
    t268: `英語`,
    t269: `フランス語`,
    t270: `ロシア語`,
    t271: `スペイン語`,
    t272: `日本語`,
    t273: `韓国語`,
    t274: `インドネシア語`,
    t275: `ベトナム語`,
    t276: `ドイツ語`,
    t277: `トルコ語`,
    t278: `イタリア語`,
    t279: `ポルトガル語`,
    t280: `タイ語`,
    t281: `マレー語`,
    t282: `アラビア語`,
    t283: `ユーザー名またはパスワードが正しくありません`,
    t284: `WeMeetの利用規約をお読みいただき、同意の上、操作を行ってください`,
    t285: `現在関連するコンテンツはありません`,
    t286: `タイプ`,
    t287: `属性`,
    t288: `詳細`,
    t289: `その他`,
    t290: `合計2商品`,
    t291: `{1}が{2}のWeMeet AI Spaceを訪れることを招待します`,
    t292: `例をクリックするか、質問を入力してください：`,
    t293: `リフレッシュ`,
    t294: `名刺をクリックして、連絡先を追加して詳細を確認することもできます：`,
    t295: `学ぶ`,
    t296: `WeMeet デジタルミーティング`,
    t297: `WeMeet デジタル展示`,
    t298: `Tarjeta de visita y Espacio WeMeet AI`,
    t299: `WeMeet 組織のメンバーになる方法`,
    t300: `WeMeet デジタル会議サービスは、会議の作成と公開、参加者の登録管理、電子チェックイン、会議スケジュール管理、会議資料の共有、リアルタイムの対話、ゲストとのやり取りなど、包括的なオンライン会議ソリューションを提供します。`,
    t301: `WeMeetデジタル展示会は、展示会のマイクロ公式ウェブサイトを迅速に構築するのに役立ちます。出展者情報、展示品紹介、展示会ライブ配信、展示会登録、イベントスケジュールなどを表示し、参加企業や観客が展示会の詳細を簡単に理解できるようにします。WeMeetデジタル展示会機能を使用するには、まず機関入居を完了してください。 "私"をクリックし、"サービスセンター"までスクロールし、"機関入居"をクリックし、指示に従って入居手続きを完了してください。`,
    t302: `WeMeetの個人ユーザーは、WeChat ID、電話番号を認証し、プラットフォームの登録を完了するだけで、個人用デジタル名刺を取得し、個人のAIラウンジ（個人履歴、更新情報、写真、文書などを含む）を維持できます。`,
    t303: `ミニプログラムの下部メニューバーで「私」オプションをクリックして、個人名刺ページを更新し、個人ホームページを改善します。`,
    t304: `大文字と小文字のアルファベット、数字、句読点を組み合わせ、文字数は8〜20文字です。`,
    t305: `製品名を入力`,
    t306: `もうありません`,
    t307: `右上隅をクリック`,
    t308: `お好みの共有方法を選択`,
    t309: `了解しました`,
    t310: `まず登録とログインを完了してください`,
    t311: `もっと詳しく知る`,
    t312: `関連製品`,
    t313: `訪問していただきありがとうございます`,
    t314: `ログアウト`,
    t315: `フォローした組織`,
    t316: `前へ`,
    t317: `次へ`,
    t318: `なし`,
    t319: `{1}が{2}を訪問するように招待しています`,
    t320: `AIラウンジは現在の言語を維持していません`,
    t321: `AIラウンジは現在の言語に切り替わりました`,
    t322: `リンクがアクティブ化されました`,
    t323: `ネットワークが混雑しています。後でもう一度お試しください`,
    t324: `製品の詳細が現在の言語に切り替わりました`,
    t325: `製品の詳細は現在、この言語で維持されていません`,
    t326: `こんにちは、私はWeMeetのインテリジェントAIアシスタントです。いつでも心のこもったサービスを提供します！何かお手伝いできることはありますか？`,
    t327: `名前を入力してください`,
    t328: `関連する連絡先情報を見つけました。以下の連絡先カードをご確認ください。`,
    t329: `添付ファイル`,
    t330: `関連する連絡先情報は見つかりませんでした。`,
    t331: `以下の担当同僚にお問い合わせを転送しました。名刺をクリックしてすぐに連絡することもできます。`,
    t332: `展示会`,
    t333: `入力してください`,
    t334: `ユーザー`,
    t335: `もうありません`,
    t336: `更新に成功しました`,
    t337: `読み込み中`,
    t338: `更新のために解放`,
  },
};
